import Vue from 'vue'
import Vuex from 'vuex'


import auth from './modules/auth';
import profile from './modules/profile';
import surveys from './modules/surveys';
import modal from './modules/modal';

import { LOADING, STOP_LOADING } from './mutation-types';

Vue.use(Vuex)

export interface RootState {
  loading: number;
  windowWidth: number;
}

export default new Vuex.Store({
  state: {
    loading: 0,
    windowWidth: window.innerWidth
  },
  mutations: {
    [LOADING]: (state) => {
      state.loading++
    },
    [STOP_LOADING]: (state) => {
      state.loading--
    },
    WINDOW_RESIZE: (state, payload) => {
      state.windowWidth = payload
    },
  },
  actions: {
    registerResizeListener(context) {
      window.addEventListener('resize', () => {
        context.commit('WINDOW_RESIZE', window.innerWidth)
      })
    }
  },
  getters: {
    screenSM: (state) => state.windowWidth >= 640,
    screenMD: (state) => state.windowWidth >= 768,
    screenLG: (state) => state.windowWidth >= 1024,
    screenXL: (state) => state.windowWidth >= 1600,
    isLoading: ({loading}) => loading > 0,
    friendlyName: (state, getters) => {
      let n = ''
      if (getters.hasProfile && getters.profile.givenname) {
        n = getters.profile.givenname
      } else if (getters.user && getters.user.displayName) {
        n = getters.user.displayName
      } else {
        n = 'Utente anonimo'
      }

      const maxl = 18
      return n.length > maxl ? n.substr(0, maxl-3) + '...' : n
    },
  },
  modules: {
    auth,
    profile,
    modal,
    surveys,
  }
})
